import { exportsModule } from '@cian/mf-registry/browser';

import { createCustomElementConstructor } from './createCustomElementConstructor';
import { createApplicationContext } from '../services/applicationContext/createApplicationContext';
import { createApplicationState } from '../services/applicationState';
import { init as initAuthContext } from '../services/authContext';
import { init as initEvents } from '../services/events';
import { registerHeaderUIAPIController } from '../services/headerUIAPIController/bridge';
import { createHeaderUIAPIController } from '../services/headerUIAPIController/createHeaderUIAPIController';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  initAuthContext(context, store);
  initEvents(context, store, false);
  const apiController = createHeaderUIAPIController(store);
  registerHeaderUIAPIController(
    {
      microfrontendName: context.config.getStrict<string>('projectName'),
      imageVersion: context.config.getStrict<string>('version.commit'),
    },
    apiController,
  );

  exportsModule({
    ui: {
      '/v3/get-header-microfrontend/': () => ({
        customElementConstructor: createCustomElementConstructor(context, store, apiController),
      }),
    },
  });
}
